import axios from "axios";
import { Message, MessageBox } from "element-ui";
import store from "../store";
import { getToken } from "@/utils/auth";

// 前端程序版本号（按项目情况调整：可从 package.json 引入或构建环境注入）
const APP_VERSION = process.env.VUE_APP_VERSION || "1.0.0";

// 获取浏览器名称与版本
function getBrowserInfo() {
  const ua = navigator.userAgent;
  let name = "Unknown";
  let version = "";

  if (/Edg\//.test(ua)) {
    // Edge 内核 UA 同时含 Chrome，需优先判断
    name = "Edge";
    const match = ua.match(/Edg\/([\d.]+)/);
    version = match ? match[1] : "";
  } else if (/Chrome\//.test(ua)) {
    name = "Chrome";
    const match = ua.match(/Chrome\/([\d.]+)/);
    version = match ? match[1] : "";
  } else if (/Firefox\//.test(ua)) {
    name = "Firefox";
    const match = ua.match(/Firefox\/([\d.]+)/);
    version = match ? match[1] : "";
  } else if (/Version\/[\d.]+.*Safari\//.test(ua)) {
    name = "Safari";
    const match = ua.match(/Version\/([\d.]+)/);
    version = match ? match[1] : "";
  } else if (/MSIE|Trident/.test(ua)) {
    name = "IE";
    const match = ua.match(/MSIE ([\d.]+)/);
    version = match ? match[1] : "11";
  }
  return { name: name, version: version };
}

// 获取设备类型
function getDeviceType() {
  const ua = navigator.userAgent;
  if (/MicroMessenger/i.test(ua)) return "WeChat"; // 微信内置浏览器
  if (/Android/i.test(ua)) return "Android";
  if (/iPhone|iPad|iPod/i.test(ua)) return "iOS";
  return "HT";
}

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000, // 请求超时时间
});
// request拦截器
service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers["Authorization"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // 自定义请求头：HT/浏览器名称/浏览器版本/前端程序版本
    const browser = getBrowserInfo();
    config.headers["X-Header"] =
      "HT/" + browser.name + "/" + browser.version + "/" + APP_VERSION;
    // 设备类型
    config.headers["X-Device-Type"] = getDeviceType();
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);
// respone拦截器
service.interceptors.response.use(
  (response) => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    if (res.code !== 200) {
      Message({
        message: res.message,
        type: "error",
        duration: 3 * 1000,
      });
      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm(
          "你已被登出，可以取消继续留在该页面，或者重新登录",
          "确定登出",
          {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            store.dispatch("FedLogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          })
          .catch(() => {});
      }
      return Promise.reject("error");
    } else {
      return response.data;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 3 * 1000,
    });
    return Promise.reject(error);
  }
);
export default service;
